import { render } from "./CommunicationStatsView.vue?vue&type=template&id=430fa0f7&scoped=true&ts=true"
import script from "./CommunicationStatsView.vue?vue&type=script&lang=ts"
export * from "./CommunicationStatsView.vue?vue&type=script&lang=ts"

import "./CommunicationStatsView.vue?vue&type=style&index=0&id=430fa0f7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430fa0f7"]])

export default __exports__